import React from "react";
import {useTranslation} from "@unibuddy/intl";
import {View, Box, Text} from "@unibuddy/patron";
import styled from "styled-components";

import useAuth from "shared/Auth/hooks/useAuth";

import {useUniversity} from "../../UniversityProvider/UniversityProvider";
import {IntlNamespaces} from "../../../../translations/types";
import {INTL_TELL_US_A_BIT_ABOUT_YOU} from "../../../../translations/common";
import {INTL_STEP_2_OF_2} from "../../../../translations/signup";
import {isFunction} from "../../../..//util/isFunction";

// FIXME: Why don't these props work when passed to <Box as="img" />
const StyledBox = styled(Box)`
    object-fit: cover;
    width: 96px;
    height: 96px;
    border-radius: 20px;
    overflow: hidden;
    display: block;
    margin: 0 auto;
`;

export function RegisterPage2Heading() {
    const {t} = useTranslation([IntlNamespaces.COMMON, IntlNamespaces.SIGNUP]);
    const {authState} = useAuth();
    const {squareLogo, name} = useUniversity();
    const firstName = authState?.me?.anyUser?.firstName ?? "Hey";

    const intlDefaultValue = isFunction(INTL_TELL_US_A_BIT_ABOUT_YOU.defaultValue)
        ? INTL_TELL_US_A_BIT_ABOUT_YOU.defaultValue(firstName)
        : INTL_TELL_US_A_BIT_ABOUT_YOU.defaultValue;

    return (
        <View gap="small-medium" paddingTop="xsmall">
            <Box>
                <Text size="medium" weight="700" align="right">
                    {t(
                        `${IntlNamespaces.SIGNUP}:${INTL_STEP_2_OF_2.key}`,
                        INTL_STEP_2_OF_2.defaultValue,
                    )}
                </Text>
                <StyledBox as="img" src={squareLogo} alt={`${name} logo`} />
            </Box>
            <Text size="large" align="center" weight="700">
                {t(INTL_TELL_US_A_BIT_ABOUT_YOU.key, intlDefaultValue, {
                    name: firstName,
                })}
            </Text>
        </View>
    );
}
